export var StripeEntity;
(function (StripeEntity) {
    StripeEntity[StripeEntity["US"] = 0] = "US";
    StripeEntity[StripeEntity["NonUS"] = 1] = "NonUS";
})(StripeEntity || (StripeEntity = {}));
//# sourceMappingURL=stripe.enum.js.map